import Home from '@/components/common/Home.vue';

export const productRoutes = {
  path: '/product',
  component: Home,
  name: 'Product',
  redirect: '/product/overall',
  meta: {
    title: 'Product',
  },
  children: [
    {
      path: 'overall',
      component: () => import('@/views/product/ProductOverall.vue'),
      meta: {
        title: 'Product Overall',
      },
    },
    {
      path: 'detail',
      component: () => import('@/views/product/ProductDetail.vue'),
      meta: {
        title: 'Product Detail',
      },
    },
  ],
};
